import React from 'react';
import { statusStyles } from 'utils/designSystem';

const StatusIndicator = ({ status, icon, children }) => {
  return (
    <span style={statusStyles[status]}>
      {icon && icon}
      {children}
    </span>
  );
};

export default StatusIndicator;
